import { fromJS } from 'immutable';
import { OPEN_ROOM_POPUP, CLOSE_ROOM_POPUP } from '../constants/room-popup';

const initialState = fromJS({
  isOpened: false,
  packageId: null,
});

export default function (state = initialState, { type, payload: packageId }) {
  switch (type) {
    case OPEN_ROOM_POPUP: {
      return state.merge(
        fromJS({
          isOpened: true,
          packageId,
        }),
      );
    }
    case CLOSE_ROOM_POPUP:
      return initialState;

    default:
      return state;
  }
}
